module.exports = __webpack_public_path__ + "img/progress_046.3ccb61b8.png";